<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label" style="width: 100%">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="validation.$error" style="color: red; padding-left: 15px;">
      {{ messages }}
    </span>
    </label>

    <select class="form-select"
            :class="{ 'is-invalid': validation?.$error }"
            aria-label="Default select example"
            v-model="selectedValue"
            @change="handleChange"
            :disabled="disabled"
            :required="required">
      <option value="">{{ placeholder }}</option>

      <option v-for="option in options" :key="option?.key ?? option?.id ?? option.value" :value="option?.key ?? option?.id ?? option.value">
        {{ option.label ?? option?.value ?? option?.name  }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [ String, Number ],
    default: '',
  },
  label: {
    type: [String, Boolean],
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  classFormGroup: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Wert auswählen',
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: [Object, String],
    default: () => ({}),
  },
  disabled: {
    type: [ Boolean ],
    default: false,
  },
});


const emit          = defineEmits([ 'update:modelValue' ]);
const selectedValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  selectedValue.value = newValue;
});

const handleChange = () => {
  emit('update:modelValue', selectedValue.value);
};

</script>

<style scoped>
</style>